import React, { useState } from 'react'
import { Link } from 'react-router-dom';
import { IconEye, IconEyeOff } from '@tabler/icons-react'

import './styles/form.css'

function FormSign() {

    const [ tooglePassword, setTooglePassword ] = useState(false);

    const handleSubmitLogin = (e) => {
        e.preventDefault();
        alert('Please enter your password');
    }

    return (

        <form className='--form-login' method='POST' onSubmit={handleSubmitLogin}>

            <div className='--form-group --form-group--flex'>

                <div className='--form-row'>

                    <label htmlFor='entryName' className='--label-form-lgn'>Nombre(s)*</label>

                    <div className='--form-control'>
                        <input type='text' className='--entry-form-lgn' name='entryName' id='entryName' placeholder='Ingresa tu nombre' aria-placeholder='Ingresa tu nombre' autoComplete='off' />
                    </div>

                </div>

                <div className='--form-row'>

                    <label htmlFor='entryLastName' className='--label-form-lgn'>Apellido(s)*</label>

                    <div className='--form-control'>
                        <input type='text' className='--entry-form-lgn' name='entryLastName' id='entryLastName' placeholder='Ingresa tu apellido' aria-placeholder='Ingresa tu apellido' autoComplete='off' />
                    </div>
                    
                </div>

            </div>

            <div className='--form-group'>

                <label htmlFor='entryEmail' className='--label-form-lgn'>Email o correo electrónico</label>

                <div className='--form-control'>
                    <input type='email' className='--entry-form-lgn' name='entryEmail' id='entryEmail' placeholder='Ingresa tu Email o correo electrónico' aria-placeholder='Ingresa tu Email o correo electrónico' autoComplete='off' />
                </div>

            </div>

            <div className='--form-group'>

                <label htmlFor='entryPassword' className='--label-form-lgn'>Contraseña</label>

                <div className='--form-control'>
                    <input type={`${tooglePassword ? 'text' : 'password'}`} className='--entry-form-lgn --entry-form-lgn--password' name='entryPassword' id='entryPassword' placeholder='Ingresa tu contraseña' aria-placeholder='Ingresa tu contraseña' autoComplete='off' />
                    <span className='--ico-form-lgn' onClick={() => setTooglePassword(!tooglePassword)}>{tooglePassword ? <IconEye/> : <IconEyeOff/>}</span>
                </div>

            </div>

            <div className='--form-group'>
                <div className='--form-control--checkbox'>
                    <input type='checkbox' name='tyc' id='tyc' />
                    <label htmlFor='tyc'>Acepto las <Link>Condiciones de uso</Link> y las <Link>Políticas de privacidad</Link> de Chambita. *</label>
                </div>
                <div className='--form-control--checkbox'>
                    <input type='checkbox' name='nyp' id='nyp' />
                    <label htmlFor='nyp'>Acepto recibir <Link>Novedades y Promociones</Link></label>
                </div>
            </div>

            <div className='--form-group'>
                <button className='--btn --btn-lgn'>Crear cuenta</button>
            </div>

            <div className='--form-group'>
                <p className='--span-form-lgn'>¿Ya tienes una cuenta?. <Link to={'/login'}>Ingresa aquí</Link></p>
            </div>

        </form>

    )

}

export default FormSign